import React from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * PhotoMarquee — infinite right-to-left strip pulling ONLY from the media library
 * (admin-uploaded photos, category=photo). Hidden entirely when no photos exist.
 */
export default function PhotoMarquee() {
  const [photos, setPhotos] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    axios.get(`${API}/media?category=photo`).then((r) => {
      const imgs = (r.data || []).filter((m) => (m.content_type || "").startsWith("image/"));
      setPhotos(imgs.slice(0, 16).map((m) => ({
        src: `${API}/media/${m.id}/file`,
        id: m.id,
      })));
    }).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  if (!loaded || photos.length === 0) return null;

  // Duplicate list for seamless loop; if fewer than 6 pics duplicate more times
  const times = photos.length < 6 ? 4 : 2;
  const row = Array.from({ length: times }).flatMap(() => photos);

  return (
    <section className="mt-5 -mx-4 sm:mx-0" data-testid="photo-marquee">
      <div className="marquee">
        <div className="marquee-track">
          {row.map((p, i) => (
            <div key={`${p.id}-${i}`} className="marquee-item" data-testid={`marquee-item-${i}`}>
              <img src={p.src} alt="" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
